/** Case-insensitive A–Z sort by `name` (states, regions, etc.). */
export function sortByName<T extends { name?: string }>(items: T[] | null | undefined): T[] {
  if (!Array.isArray(items)) return [];
  return [...items].sort((a, b) =>
    String(a?.name ?? '').localeCompare(String(b?.name ?? ''), undefined, { sensitivity: 'base' })
  );
}
